class BUProductSlider {
    constructor($el) {
        this.$el = $el;
        this.$dots = null;
        this.$nextBtn = null;

        this.options = {
            pageDots: true,
            wrapAround: false,
            prevNextButtons: true,
            cellSelector: '.bu-products__item',
            cellAlign: 'left',
            groupCells: '100%'
        };

        if(this.$el.length) {
            this._createSlider();
            this._findDOMElements();
            this._reposition();
            // this._bindEvents();
        }
    }

    _createSlider() {
        this.$el.flickity(this.options);
    }

    _bindEvents() {
        $(window).on('resize', this._reposition.bind(this));
    }

    _findDOMElements() {
        this.$dots = this.$el.find('.flickity-page-dots');
        this.$nextBtn = this.$el.find('.flickity-prev-next-button.next');
    }

    _reposition() {
        if(this.$dots && this.$nextBtn) {
            this.$nextBtn.css('left', this.$dots.outerWidth());
        }
    }
}

export default BUProductSlider;
